/**
 * Interactions Page
 * All activity across organizations (servicing activity, event reward records, support-task notes).
 *
 * It used to read `data.interactions` while getInteractions returns `data`, so it always showed
 * "No interactions found" and its Edit/Delete buttons were unreachable (reward-log audit R2-1). It now
 * reuses the same list/form as the organization Interactions tab. `?interaction=<id>` opens one
 * record (the target of the Activity Log and Support Tasks links; there is no /interactions/:id route).
 */

import React from "react";
import { useSearchParams } from "react-router-dom";
import InteractionsTab from "../components/interactions/InteractionsTab";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const Interactions: React.FC = () => {
  const [searchParams] = useSearchParams();
  const requested = searchParams.get("interaction");
  const initialInteractionId =
    requested && UUID_RE.test(requested) ? requested : null;

  return (
    <div className="p-6">
      <InteractionsTab
        initialInteractionId={initialInteractionId}
        title="Interactions"
        description="All activity across organizations, newest first: servicing activity, event reward records and support-task notes."
      />
    </div>
  );
};

export default Interactions;
